import { ReactElement, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import { setLoading } from '../../../services/reducers/homeSlice';
import tools from '../../../utils/tools';

const FitFor = ({ form, setForm, years, cars }) => {
  const [selected, setSelected] = useState<any>(form?.fitFors || []);
  const dispatch = useDispatch();

  const list = () => {
    const rows: ReactElement[] = [];

    selected.map((value, index) => {
      const itemIndex = selected.findIndex(e => e.car == value.car && e.year == value.year && e.toYear == value.toYear);

      rows.push(
        <section className={`addProductInfo fitFor ${index % 2 !== 0 ? 'backGround' : ''}`}>
          <div className="selectorContainer width100">
            <label className="sideBarTitle">خودرو</label>
            <Select options={tools.selectFormatter(cars, 'id', 'slug', 'انتخاب کنید')} defaultValue={selected[itemIndex].car || form?.carId} value={tools.selectFormatter(cars.filter(e => e.id == selected[itemIndex].car), 'id', 'slug')} className="width23"
                    onChange={(selected) => {
                      setSelected(prevState => {
                        const cp = [...prevState];
                        cp[itemIndex].car = selected.value.toString();
                        return cp;
                      });
                    }}
            />
            <label className="sideBarTitle">از سال</label>
            <select className="selector1" defaultValue={selected[itemIndex].year} onChange={(input) => {
              setSelected(prevState => {
                const cp = [...prevState];
                cp[itemIndex].year = input.target.value
                return cp;
              });
            }}>
              <option value="">همه سال ها</option>
              {years.map(e => <option value={e.id}>{`${e.jalali} - ${e.greg}`}</option>)}
            </select>
            <label className="sideBarTitle">تا سال</label>
            <select className="selector1" defaultValue={selected[itemIndex].toYear} onChange={(input) => {
              setSelected(prevState => {
                const cp = [...prevState];
                cp[itemIndex].toYear = input.target.value
                return cp;
              });
            }}>
              <option value="">همه سال ها</option>
              {years.map(e => <option value={e.id}>{`${e.jalali} - ${e.greg}`}</option>)}
            </select>
          </div>
        </section>
      );
    });

    return rows;
  };

  useEffect(() => {
    setForm((prev) => ({
      ...prev,
      fitFors: selected
    }));
  }, [selected]);

  return (
    <div className="AddInfoContainer">
      {list()}
      <button className="dashboardHeader" onClick={() => setSelected(prev => [...prev, {}])}>
        افزودن +
      </button>
    </div>
  );
};

export default FitFor;
